/* eslint-disable react/function-component-definition */
import { cloneElement, createElement, forwardRef } from "react";
import cx from "classnames";
import type { ButtonProps } from "@jnctn/bridge-design-system/types/Button";

export type { ButtonProps };

const UnforwardedButton = (
  {
    children,
    className,
    label,
    labelHidden = false,
    title,
    onClick,
    style,
    disabled = false,
    icon,
    rightIcon,
    tabIndex,
    element = "button",
    ariaLabel,
    submit,
  }: ButtonProps,
  ref
) => {
  const elementProps = {
    "aria-label": ariaLabel || label,
    className: cx("select-none", className, { "cursor-pointer": !disabled }),
    onClick: onClick,
    style: style,
    type: submit ? "submit" : "button",
    title: title,
    disabled: disabled,
    tabIndex: tabIndex,
    children: (
      <>
        {icon}
        {labelHidden ? undefined : children || label}
        {rightIcon}
      </>
    ),
    ref: ref,
  };
  return typeof element === "string"
    ? createElement(element, elementProps)
    : cloneElement(element, elementProps as any);
};

const Button = forwardRef(UnforwardedButton);

export default Button;
